module.exports = __webpack_public_path__ + "img/asian-starters-1.a539adfe.jpg";